<span (click)="onClick()" [ngStyle]="{'font-size': fontSize, 'color': color}">{{ text }}</span>
